module.exports = __webpack_public_path__ + "4f0b1d07727d193f5ca02d2d8f318cfe.png";